// Main interface
export { ChatInterface } from "./components/ChatInterface";

// Components
export { Input } from "./components/Input";
export { InputArea } from "./components/InputArea";
export { SolaMessage } from "./components/Message";
export { MessageList } from "./components/MessageList";
export { Greeting } from "./components/Greeting";
export { UsageDisplay } from "./components/UsageDisplay";

// Store and hooks (all from new lib location)
export {
  useChatStore,
  selectMessageIds,
  selectMessage,
  selectStatus,
  selectUsage,
  type ChatState,
  type Message
} from "@/lib/sola/store";

// Types and utilities
export type {
  SolaMessagePart,
  SolaContext,
  SOLAConfig,
  SolaUsage,
  SolaVisibilityType,
  SOLAAttachment,
} from "@/lib/sola/types";

// Transport
export { SOLATransport } from "@/lib/sola/transport";

// Configuration
export { SOLA_CONFIG, SOLA_SYSTEM_PROMPT } from "@/lib/sola/config";

// Hooks
export { useSolaContext } from "@/hooks/use-sola-context";